import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './LoginPage.css';
import { useConcerns } from '../../contexts/ConcernContext';
import { api } from '../../utils/authApi';

function LoginPage() {
  const API_ADDRESS = process.env.REACT_APP_API_URL;
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const { changeProject } = useConcerns();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      // Login request (no JWT needed for login endpoint)
      const response = await fetch(`${API_ADDRESS}/users/auth/login`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          email: email,
          password: password
        })
      });

      const data = await response.json();
      console.log('Token:', localStorage.getItem('token'));
      console.log('User Info:', localStorage.getItem('user_info'));
      console.log('Success:', data.success);
      console.log('Login response:', data);
      console.log('Message:', data.message);

      if (data.success) {
        // Store JWT token
        localStorage.setItem('token', data.token);
        
        // Store user info
        localStorage.setItem('user_info', JSON.stringify({
          user_id: data.user_id,
          email: data.email,
          role: data.role
        }));
        
        // Navigate based on user role
        if (data.role === 'client') {
          const user_id = data.user_id;

          // Now use authenticated API call to get projects
          const projectResponse = await api.get(`/projects/${user_id}`);
          const projects = await projectResponse.json();
          
          if (projects.projects.length > 1) {
            navigate('/select-project')
          } else {
            localStorage.setItem('selectedProject', JSON.stringify({
              "projectID": projects.projects[0][0],
              "projectLocation": projects.projects[0][2]
            }))    
            changeProject(projects.projects[0][0]);
            navigate('/client-dashboard');
          }
        } else if (data.role === 'engineer') {
          navigate('/engineer-dashboard');
        }
      } else {
        setError('Invalid Password or Email');
      }

    } catch (error) {
      console.error('Network error:', error);
      setError('Network error. Please check if the backend is running.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-page">
      <div className="login-container">
        <div className="login-card">
          <h2 className="login-title">Welcome Back</h2>
          <p className="login-subtitle">Sign in to your account</p>

          {error && (
            <div className="error-message">
              {error}
            </div>
          )}

          <form onSubmit={handleSubmit} className="login-form">
            <div className="form-group">
              <label htmlFor="email">Email</label>
              <input
                type="email"
                id="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="your.email@example.com"
                required
              />
            </div>

            <div className="form-group">
              <label htmlFor="password">Password</label>
              <input
                type="password"
                id="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="Enter your password"
                required
              />
            </div>

            <button 
              type="submit" 
              className="btn btn-primary btn-full"
              disabled={loading}
            >
              {loading ? 'Signing In...' : 'Sign In'}
            </button>
          </form>

          <p className="back-link">
            <a href="/">← Back to Home</a>
          </p>
        </div>
      </div>
    </div>
  );
}

export default LoginPage;